﻿export interface IInvoiceDetailReport {
    id: number,
    invoiceNumber: number,
    invoiceNumberDisplay: string,
    centerId: number,
    centerAlias: string,
    centerName: string,
    centerState: string,
    organType: number,
    invoiceYear: number,
    invoiceMonth: number,
    transplantCount: number,
    amountDue: number,
    amountPaid: number,
    annualMembershipFee: number,
    annualDcnFee: number,
    technologySupportFee: number,
    nkrFee: number,
    dashFee: number,
    crossMatchFee: number,
    crossMatchKitFee: number,
    crossMatchVibtFee: number,
    vxmFee: number,
    serologyFee: number,
    serologyFeeDirect: number,
    serologyKitFee: number,
    logisticsFee: number,
    logisticsFeeLiver: number,
    shippingFee: number,
    transplantFee: number,
    transplantLiverFee: number,
    opoFee: number,
    dppFee: number,

    patientTypingFee: number,
    typingFee: number,
    typingSwabKit: number,
    typingAndCryoFee: number,
    typingCryoKit: number,

    researchSupportFee: number,
    donorInsuranceAndSupport: number,
    donorInsuranceAndSupportLiver: number,
    donorShieldCredits: number,
    donorShieldCreditsLiver: number,
    streamlinedBillingFee: number,
    donorWorkupFee: number,
    ctFee: number,
    medicaidFee: number,
    homeBloodDrawFee: number,
    homeBloodDrawKit: number,
    phlebotFee: number,
    donorShieldFee: number,
    donorShieldLiverFee: number,
    pwlQuestFee: number,
    pwlPhlebotFee: number,
    pwlJugOnlyFee: number,
    physicianCharge: number,
    anesthesiaCharge: number,
    hospitalCharge: number,
    streamlinedHospitalBillingFee: number,
    pwlPerTransplantFee: number,
    rmcrFeeMinor: number,
    rmcrFeeMajor: number,
    monthlyInactivityFee: number,

    dashFeeLiver: number,
    transplantTypingFee: number,
    remoteRiskPremium: number,
    incompatiblePairRiskPremium: number,
    privateInsuranceRiskPremium: number,
    pwlPhlebotKit: number
}
